
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M31.1 18.3a1 1 0 01-1.4-.2 6.451 6.451 0 00-5.2-2.6 1 1 0 110-2 3 3 0 10-2.95-3.563 1 1 0 11-1.963-.375 5.001 5.001 0 118.288 4.625A8.476 8.476 0 0131.3 16.9a1 1 0 01-.2 1.4zm-7 8.262a1.012 1.012 0 01-.463 1.338 1.16 1.16 0 01-.437.1 1.012 1.012 0 01-.9-.563 7.013 7.013 0 00-12.6 0 .999.999 0 01-1.841-.112 1.013 1.013 0 01.041-.763 9.013 9.013 0 014.45-4.3 6 6 0 117.3 0 9.013 9.013 0 014.45 4.3zM16 21.5a4 4 0 10-4-4 4.013 4.013 0 004 4zm-7.5-7a1 1 0 00-1-1 3 3 0 112.95-3.563 1 1 0 101.963-.375 5 5 0 10-8.288 4.625A8.476 8.476 0 00.7 16.9a1 1 0 001.6 1.2 6.45 6.45 0 015.2-2.6 1 1 0 001-1z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      